var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "omni-dropdown-card"
  }, _vm._l(_vm.cardItems, function (item, key) {
    return _c('div', {
      key: key,
      staticClass: "card-item"
    }, [item.openInCurrentTab ? _c('a', {
      attrs: {
        "href": _vm.parseLink(item.value)
      }
    }, [_vm._v(" " + _vm._s(_vm.parseLabel(item.label)) + " ")]) : _c('a', {
      attrs: {
        "href": _vm.parseLink(item.value),
        "target": "_blank"
      }
    }, [_vm._v(" " + _vm._s(_vm.parseLabel(item.label)) + " ")])]);
  }), 0);

}
var staticRenderFns = []

export { render, staticRenderFns }